import { Controller } from 'stimulus'

import { getPlansController } from '../../_js/controllers/plans-controller'
import { getPlanPriceValueByKey } from '../../_js/base/plans'

export default class PriceController extends Controller {
  static values = {
    // The identifier value is basically a key for the plan value,
    // you can see the available keys on "_js/base/plans.js"
    identifier: String,
  }

  unsubscribe = null

  initialize() {
    const plansController = getPlansController(this.application)

    // If the controller is not mounted or found, we fail to mount
    // however the user don't see any update
    if (!plansController) {
      return
    }

    const observable = plansController.getObservable()
    this.unsubscribe = observable.subscribe(({ plans, currency }) => {
      if (!plans || !currency) {
        return
      }

      const price = getPlanPriceValueByKey(plans, this.identifierValue, currency)

      if (price) {
        this.element.textContent = price

        // Force reflow to update the text content
        // https://linear.app/sketch/issue/SWEB-1543/eurusd-pricing-text-not-rendering-properly
        if (this.element instanceof HTMLElement) {
          // eslint-disable-next-line no-unused-expressions
          this.element.parentElement.offsetWidth
        }
      } else {
        this.element.textContent = ''
      }
    })
  }

  disconnect() {
    this.unsubscribe?.()
  }
}
